import { add } from 'date-fns';
import { formatDashedYYYYMMDD, parseDate, stringifySource } from 'utils';
import type { PricedBlueprint } from '~/components/BlueprintIndex/BlueprintIndexSearch/BlueprintIndexSearch';
import { getDefaultOriginId } from '~/constants/default-origin';

export type CreateJourneyBody = {
  adult_count: number;
  childAges: number[];
  room_count: number;
  closest_city: number;
  startDate: string;
  endDate: string;
  twinRoomPreferred: boolean;
  journeyId: string;
  originLocationId: number;
  buildParameters: {
    regionId: string;
    journeyTitleOverride: string;
  };
  requestSource: string;
  useYearRoundPricingCache: boolean;
  updateSelectedJourney: boolean;
};

export const buildJourneyRequestBody = (
  blueprint: PricedBlueprint,
  startDate: string,
  locale?: string
): CreateJourneyBody | null => {
  if (!startDate) return null;

  const originId = getDefaultOriginId(locale);

  const endDate = add(parseDate(startDate), { days: blueprint.duration });
  const formattedEndDate = formatDashedYYYYMMDD(endDate);

  return {
    adult_count: 2,
    childAges: [],
    room_count: 1,
    closest_city: originId,
    startDate: formatDashedYYYYMMDD(startDate),
    endDate: formattedEndDate,
    twinRoomPreferred: false,
    journeyId: blueprint.blueprintId,
    originLocationId: originId,
    buildParameters: {
      regionId: blueprint.region,
      journeyTitleOverride: blueprint.title
    },
    requestSource: stringifySource({
      environment: process.env.NEXT_PUBLIC_SOURCE_ENV,
      name: 'blueprintIndex',
      action: 'create'
    }),
    useYearRoundPricingCache: true,
    updateSelectedJourney: false
  };
};

export const getCacheKey = (blueprintId: string, startDate: string | null): string[] => {
  return startDate
    ? ['journeyFromBlueprint', blueprintId, formatDashedYYYYMMDD(startDate)]
    : ['journeyFromBlueprint', blueprintId, 'no-start'];
};

export const getPlacesOverview = (places: string): string => {
  const placesArr = places.split(', ');
  const placesArrLength = placesArr.length;
  if (placesArrLength > 8) {
    return `${placesArr.slice(0, 8).join(', ')}...`;
  }
  return placesArr.join(', ');
};
